import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const MedReasonPresForm = (props) => {
    const initialFormData = {
        rsnprescrib: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    const formRef = useRef(null);

    useEffect(() => {
        const val = props.medreasonvalue || props.medrsnvalue;
        if (val && (val.reason_pres_id || val.reason_id || val.id)) {
            const { reason, reason_prescribed, is_active, reason_pres_id, reason_id, id } = val;
            setFormData({
                rsnprescrib: reason || reason_prescribed || "",
                isactive: is_active == 1 || is_active === '1' || is_active === true,
                id: reason_pres_id || reason_id || id || ""
            });
            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        } else {
            setFormData(initialFormData);
            setButtonStatus(mapYourMedsConstant.ADD_ACTION);
        }
    }, [props.edittrigger, props.medreasonvalue, props.medrsnvalue]);

    const isAddMode = buttonStatus === "Add" || buttonStatus === mapYourMedsConstant.ADD_ACTION;

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsPresReasonUrl = isAddMode ? `${process.env.REACT_APP_SERVER_URL}/prescriptions/add-prescription-reason/` : `${process.env.REACT_APP_SERVER_URL}/prescriptions/update-prescription-reason/`;
        let pelmedsPresReasonData = isAddMode ? 
            { "reason": formData.rsnprescrib, "group_id": localStorage.getItem("groupId") || '', "is_active": 1 } :
            { "reason": formData.rsnprescrib, "group_id": localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0, "id": formData.id };

        const { data } = await axios.post(pelmedsPresReasonUrl, pelmedsPresReasonData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (data.status) {
            toast.success(isAddMode ? "Prescription Reason added successfully" : "Prescription Reason updated successfully");
        }
        else {
            toast.info("Error while adding/updating Prescription Reason");
        }

        setFormData(initialFormData);
        formRef.current.reset();
        setButtonStatus("Add");

        if (props.onCallParent) {
            props.onCallParent();
        }
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Reason Prescribed</Form.Label>
                        <Form.Control
                            placeholder='Reason Prescribed'
                            value={formData.rsnprescrib}
                            name="rsnprescrib"
                            size="sm"
                            as="textarea"
                            rows={4}
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            className="mt-4 w-50"
                            size="sm"
                            disabled={!formData.rsnprescrib}>
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group>
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={isAddMode ? true : formData.isactive}
                            disabled={isAddMode}
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};

MedReasonPresForm.propTypes = {
    medreasonvalue: PropTypes.any,
    medrsnvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default MedReasonPresForm;
